/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createDataActionHook, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { TelemetryEvent } from '@msdyn365-commerce/telemetry-internal';
import { getProductInfoFromSimpleProduct } from './telemetry.action.helper';

const beforeGetById = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

const afterGetById = async (
    _inputs: IActionInput | IActionInput[],
    simpleProduct: SimpleProduct | SimpleProduct[],
    actionContext: IActionContext
) => {
    simpleProduct = await Promise.resolve(Array.isArray(simpleProduct) ? simpleProduct[0] : simpleProduct);

    // If simple product result is defined run the post hook
    if (simpleProduct) {
        const productInfo = getProductInfoFromSimpleProduct(simpleProduct, actionContext.requestContext);
        actionContext.requestContext.telemetryData[productInfo.productSku] = productInfo;
        actionContext.requestContext.telemetryData[TelemetryEvent.ProductPageView] = productInfo ? [productInfo] : [];
    }
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Products/GetById',
    postReaderHook: afterGetById,
    preReaderHook: beforeGetById
});
